/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Aiflowcoverchoice3Inputs */

const en_aiflowcoverchoice3 = /** @type {(inputs: Aiflowcoverchoice3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The text is ready. Now the cover: should Pulsify design one, or do you use your own photo?`)
};

const de_aiflowcoverchoice3 = /** @type {(inputs: Aiflowcoverchoice3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Der Text steht. Jetzt das Cover: Soll Pulsify eins gestalten, oder nimmst du ein eigenes Foto?`)
};

/**
* | output |
* | --- |
* | "The text is ready. Now the cover: should Pulsify design one, or do you use your own photo?" |
*
* @param {Aiflowcoverchoice3Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const aiflowcoverchoice3 = /** @type {((inputs?: Aiflowcoverchoice3Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Aiflowcoverchoice3Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_aiflowcoverchoice3(inputs)
	return de_aiflowcoverchoice3(inputs)
});
export { aiflowcoverchoice3 as "aiFlowCoverChoice" }